<template>
  <zg-transition-fade>
    <div
      v-if="items && items.length"
      key="zg-stoc"
      class="zg-stoc"
    >
      <ul>
        <li
          v-for="item in items"
          :key="item.id"
        >
          <a
            :href="`#${item.id}`"
            :class="{ 'active--link': item.id === highlightedId }"
            @click.prevent="$emit('clickItem', item)"
          >
            {{ item.text }}
          </a>
        </li>
      </ul>
    </div>
  </zg-transition-fade>
</template>

<script>
  import ZgTransitionFade from '../ZgTransitionFade/ZgTransitionFade.vue'

  export default {
    name: 'ZgStickyTableOfContents',
    components: { ZgTransitionFade },
    props: {
      /**
       * Array of objects. Each object should contain at least `text` (string) and `id` (string).
       */
      items: {
        type: Array,
        required: true,
        validator: items => !items.some(item => !(item.id && item.text))
      },
      /**
       * The highlighted id. Used for styling the correct item
       */
      highlightedId: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-stoc {
    display: none;
  }

  @include mq(large) {
    .zg-stoc {
      display: flex;
      justify-content: center;
      background-color: color(brand-100);
      width: 100%;
    }

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 100%;
      max-width: rem(1080px);
      list-style: none;
      margin: 0 auto;
      overflow-x: auto;
      padding: rhythm(xsmall) 0 0;
    }

    li {
      list-style: none;
    }

    a {
      @include type-title-xxs;

      font-weight: font-weight(bold);

      white-space: nowrap;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: rem(11px) rem(12px) rem(19px);
      list-style: none;
      border-bottom: none;
      border-radius: rhythm() rhythm() 0 0;
      margin: 0;

      &.active--link {
        background-color: color(white);
      }

      &:hover {
        background-color: color(white);
        color: color(brand-500);
      }
    }
  }
</style>
